import { gql } from 'apollo-angular';

export const learningResourceSetMinimal = gql`
  fragment LearningResourceSetMinimal on LearningResourceSet {
    id
    title
    description
    betaOnly
    visibleForRoleTypes
    order
  }
`;
